import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=33dcdc58&scoped=true&"
import script from "./MessageText.vue?vue&type=script&lang=js&"
export * from "./MessageText.vue?vue&type=script&lang=js&"
import style0 from "./MessageText.vue?vue&type=style&index=0&id=33dcdc58&scoped=true&lang=css&"
import style1 from "./MessageText.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dcdc58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33dcdc58')) {
      api.createRecord('33dcdc58', component.options)
    } else {
      api.reload('33dcdc58', component.options)
    }
    module.hot.accept("./MessageText.vue?vue&type=template&id=33dcdc58&scoped=true&", function () {
      api.rerender('33dcdc58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageText.vue"
export default component.exports